import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>🚀 Learn for Fun</h3>
          <p>
            Live, coach-led skill-building adventures that mix technology, creativity, and interactive learning so every learner feels like the main character.
          </p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/sessions">Available Sessions</Link></li>
            <li><Link to="/">Sign In / Sign Up</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Legal</h4>
          <ul>
            <li><Link to="/terms-of-service">Terms of Service</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <ul>
            <li>Email: <a href="mailto:info@learnforfun.online">info@learnforfun.online</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {currentYear} Learn for Fun. All rights reserved.</p>
        <p className="footer-tagline">Empowering young minds through interactive learning</p>
      </div>

      <div className="footer-legal-disclaimer">
        <h4>⚖️ Legal Disclaimer</h4>
        <p>
          The programs offered through this website are private tutoring and educational enrichment sessions designed to teach various skills including coding, technology, creative arts, and other educational topics to children. We are not a school, academy, childcare center, or state-licensed educational institution.
        </p>
        <p>
          Our classes are short-duration learning sessions and are provided strictly for educational purposes. They do not replace formal schooling and should not be interpreted as accredited academic instruction.
        </p>
        <p>
          We do not provide childcare, daycare services, or supervision beyond class hours. Parents or guardians are responsible for the care, safety, and supervision of their children outside the scheduled class time.
        </p>
        <p>
          Participation in our programs is voluntary. Learning outcomes may vary based on student engagement and practice. All materials, lessons, and content provided are for instructional use only. By enrolling in our programs, parents/guardians acknowledge and accept these terms.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
